import classNames from "components/ui/classNames";
import { RadioGroup, RadioGroupItem } from "components/ui/RadioGroup";
import { DollarSignIcon, PercentIcon } from "lucide-react";

export enum DisplayFormat {
  Percent = "PERCENT",
  Financial = "FINANCIAL",
}

interface DisplayFormatSelectorProps {
  value: DisplayFormat;
  onChange: (displayFormat: DisplayFormat) => void;
}
export default function DisplayFormatSelector({ value, onChange }: DisplayFormatSelectorProps) {
  return (
    <RadioGroup
      loop={false}
      className={classNames(
        "grid w-full grid-cols-2 justify-between rounded-2xl border border-slate-200 bg-slate-50/60 p-1",
        "sm:flex sm:w-auto sm:max-w-24 sm:justify-normal sm:space-x-2",
        "dark:border-slate-950 dark:bg-slate-700 dark:text-slate-300",
      )}
      orientation="horizontal"
      value={value}
      onValueChange={(value) => onChange(value as DisplayFormat)}
    >
      <RadioGroupItem
        key={DisplayFormat.Percent}
        value={DisplayFormat.Percent}
        disabled={false}
        className={classNames(
          "h-9 w-full items-center justify-center rounded-xl p-1 text-center sm:w-10",
          "border border-transparent text-sm font-medium tracking-wide text-slate-500 data-[state=checked]:border-teal-800/30",
          "data-[state=checked]:bg-teal-50 data-[state=checked]:font-bold data-[state=checked]:text-teal-600",
          "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gray-100 focus-visible:ring-offset-1 focus-visible:ring-offset-gray-300",
          "data-[state=checked]:focus-visible:rounded-xl data-[state=checked]:focus-visible:bg-gray-50 data-[state=checked]:focus-visible:text-gray-600",
        )}
      >
        <PercentIcon />
      </RadioGroupItem>
      <RadioGroupItem
        key={DisplayFormat.Financial}
        value={DisplayFormat.Financial}
        disabled={false}
        className={classNames(
          "h-9 w-full items-center justify-center rounded-xl p-1 text-center sm:w-10",
          "border border-transparent text-sm font-medium tracking-wide text-slate-500 data-[state=checked]:border-teal-800/30",
          "data-[state=checked]:bg-teal-50 data-[state=checked]:font-bold data-[state=checked]:text-teal-600",
          "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gray-100 focus-visible:ring-offset-1 focus-visible:ring-offset-gray-300",
          "data-[state=checked]:focus-visible:rounded-xl data-[state=checked]:focus-visible:bg-gray-50 data-[state=checked]:focus-visible:text-gray-600",
        )}
      >
        <DollarSignIcon />
      </RadioGroupItem>
    </RadioGroup>
  );
}
